import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "" }
const _hoisted_29 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_30 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = { class: "mt-15 mt-md-0" }
const _hoisted_37 = { class: "pagination mb-0" }
const _hoisted_38 = {
  key: 0,
  class: "page-item"
}
const _hoisted_39 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "page-item"
}
const _hoisted_42 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_44 = { class: "modal-content" }
const _hoisted_45 = { class: "modal-header" }
const _hoisted_46 = { class: "modal-title fs-5" }
const _hoisted_47 = { class: "modal-body" }
const _hoisted_48 = { style: {} }
const _hoisted_49 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_52 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_56 = { style: {"color":"#FFF"} }
const _hoisted_57 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header" }
const _hoisted_61 = { class: "modal-title fs-5" }
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_64 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_65 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_66 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_67 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_68 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-4" }
const _hoisted_71 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = { class: "invalid-feedback" }
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = ["placeholder"]
const _hoisted_77 = { class: "invalid-feedback" }
const _hoisted_78 = { class: "col-md-4" }
const _hoisted_79 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "invalid-feedback" }
const _hoisted_82 = { class: "modal-footer" }
const _hoisted_83 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_84 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_85 = {
  class: "modal fade",
  id: "companyModal1",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_86 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_87 = { class: "modal-content" }
const _hoisted_88 = { class: "modal-header" }
const _hoisted_89 = { class: "modal-title fs-5" }
const _hoisted_90 = { class: "modal-body" }
const _hoisted_91 = { style: {"margin-bottom":"5%"} }
const _hoisted_92 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_93 = {
  class: "text-black fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_94 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_95 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_96 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_97 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_98 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_99 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-md-4" }
const _hoisted_102 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_103 = ["placeholder"]
const _hoisted_104 = { class: "invalid-feedback" }
const _hoisted_105 = { class: "col-md-4" }
const _hoisted_106 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_107 = ["placeholder"]
const _hoisted_108 = { class: "invalid-feedback" }
const _hoisted_109 = { class: "col-md-4" }
const _hoisted_110 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_111 = ["placeholder"]
const _hoisted_112 = { class: "invalid-feedback" }
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-md-4" }
const _hoisted_115 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_116 = { value: "" }
const _hoisted_117 = ["value"]
const _hoisted_118 = { class: "col-md-4" }
const _hoisted_119 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_120 = ["placeholder"]
const _hoisted_121 = { class: "invalid-feedback" }
const _hoisted_122 = { class: "col-md-4" }
const _hoisted_123 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_124 = { value: "" }
const _hoisted_125 = ["value"]
const _hoisted_126 = { class: "modal-footer" }
const _hoisted_127 = {
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_128 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_129 = {
  class: "modal fade",
  id: "importContact",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_130 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_131 = { class: "modal-content" }
const _hoisted_132 = { class: "modal-header" }
const _hoisted_133 = { class: "modal-title fs-5" }
const _hoisted_134 = { class: "modal-body" }
const _hoisted_135 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_136 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_137 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_138 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_139 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_140 = {
  key: 2,
  style: {"margin-top":"5%"}
}
const _hoisted_141 = { style: {"float":"right"} }
const _hoisted_142 = { style: {"float":"right"} }
const _hoisted_143 = { style: {"float":"right"} }
const _hoisted_144 = {
  key: 0,
  class: "fw-bold mb-0"
}
const _hoisted_145 = {
  key: 1,
  style: {"color":"red"},
  class: "text-red fw-bold mb-0"
}
const _hoisted_146 = { key: 3 }
const _hoisted_147 = {
  class: "form-group mb-15 mb-sm-20 mb-md-25",
  style: {"margin-top":"5%"}
}
const _hoisted_148 = { class: "row" }
const _hoisted_149 = { class: "col-md-4" }
const _hoisted_150 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_151 = { class: "col-md-4" }
const _hoisted_152 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_153 = { value: "" }
const _hoisted_154 = { value: "SN" }
const _hoisted_155 = { value: "CI" }
const _hoisted_156 = { class: "invalid-feedback" }
const _hoisted_157 = { class: "col-md-4" }
const _hoisted_158 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_159 = { class: "invalid-feedback" }
const _hoisted_160 = { class: "table-responsive" }
const _hoisted_161 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_162 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_163 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_164 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_165 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_166 = { class: "d-flex align-items-center" }
const _hoisted_167 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_168 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_169 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_170 = { class: "modal-footer" }
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../../router/index'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Operator, Contact, Business } from "@/utils/Model";
import { current_permissions } from '../../../utils/permission';
import "intl-tel-input/build/css/intlTelInput.css";
import 'vue-tel-input/vue-tel-input.css';
import intlTelInput from 'intl-tel-input';
import { validate_phone_number, showToast, checkSessionValidate, checkTelSize, checkTelFormat, checkDuplicateTelBis } from "../../../utils/function";
import { read, utils } from 'xlsx';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsContent',
  setup(__props) {

const backApi = inject('back');
const btnLoad = ref(true);
const checking = ref(false);
const { t } = useI18n();
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedBusiness = ref(null);
const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

// Toutes les lignes reçues du back
const allContacts = ref(new Array<Contact>());
const business = ref(new Array<Business>());
const operators = ref(new Array<Operator>());
let edit = 0;
let itemCode = '';
let country_code = 'ci';
let phoneMask = process.env.VUE_APP_CI_PHONE_LENTGH;
let telSizeResult = ref(0);
let telFormatResult = ref(0);
let duplicateTelResult = ref(0);
let totalChecking = 0;
let checkingResult = true;
let contactsJson = [];
const massContact = ref([]);
const payoutBalance = ref(0);
let balance: number = 0;
let iti: any;

// --- Pagination / recherche côté FRONT ---
const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const filteredContacts = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allContacts.value;
  return allContacts.value.filter((c: any) => {
    const values = [
      c.code,
      c.organization?.name,
      c.first_name,
      c.last_name,
      c.contact
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredContacts.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const paginatedContacts = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredContacts.value.slice(start, start + pageSize.value);
});

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'phone': '', 'first_name': '', 'last_name': '', 'amount': 0 };
const pageLoad = ref(false);

const formValues = reactive({
  phone: "",
  first_name: "",
  last_name: "",
  amount: 0
});

const schema = yup.object({
  phone: yup.string().required('Le numéro de téléphone est requis'),
  first_name: yup.string().required('Le nom est requis'),
  last_name: yup.string().required('Le prénom est requis'),
  amount: yup.number().required('Le montant est requis'),
});

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleBusinessChange(event) {
  selectedBusiness.value = event.target.value;
}

function handleCountryChange(event) {
  selectedCountry.value = event.target.value;
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  if (operatorArr.length > 0) {
    phoneMask = operatorArr[0].phoneMask;
  }
}

let operatorsTemp = new Array<Operator>();

function getModelExcel() {
  window.open(`/model_contact.xls`, "_blank");
}

const initField = () => {
  formValues.phone = '';
  formValues.first_name = '';
  formValues.last_name = '';
  country_code = '';
  edit = 0;
  errors.value = '';
  errorId.value = '';
  success.value = '';
}

function handlePhone(myvalue, tag) {
  country_code = iti.getSelectedCountryData().iso2;
  let phone_length = 0;
  switch (country_code) {
    case 'ci':
      phone_length = process.env.VUE_APP_CI_PHONE_LENTGH;
      break;
    case 'sn':
      phone_length = process.env.VUE_APP_SN_PHONE_LENTGH;
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length)
}

const fetchContactsPage = (targetPage: number) => {
  const isPrivileged = role === 'SUPERADMIN' || role === 'BUSINESS' || role === 'SUPPORT';

  let baseUrl = '';
  if (isPrivileged) {
    baseUrl = `${backApi}/secure/contactbooks/extended/`;
  } else {
    baseUrl = `${backApi}/secure/contactbooks?organization=${codeOrganization}`;
  }

  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllContacts = async () => {
  try {
    const first = await fetchContactsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchContactsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allContacts.value = collected;
    data = collected;
    page.value = 1;
    console.log('Contacts chargés:', collected.length);
  } catch (error: any) {
    console.error('Erreur chargement contacts:', error);
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const showContact = (code) => {
  axios.get(backApi + '/secure/contactbooks/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.phone = response.data.contact;
    formValues.first_name = response.data.first_name;
    formValues.last_name = response.data.last_name;
    itemCode = response.data.code;
    country_code = response.data.country_code;
    edit = 1;
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const showTransfert = (code) => {
  axios.get(backApi + '/secure/contactbooks/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.phone = response.data.contact;
    formValues.first_name = response.data.first_name;
    formValues.last_name = response.data.last_name;
    itemCode = response.data.code;
    country_code = response.data.country_code;
    selectOperatorByCountry(country_code);
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const getBalancePayout = () => {
  axios.post(backApi + `/secure/accounts/balance/payout`, {
    code: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    payoutBalance.value = response.data.balance;
    balance = response.data.balance;
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const getOperators = () => {
  axios.get(backApi + '/public/operators/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    operatorsTemp = response.data;
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

function selectOperatorByCountry(countryCode) {
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == countryCode) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

const getBusiness = () => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `?organization=${codeOrganization}`;
  axios.get(backApi + '/secure/business' + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    business.value = response.data.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showScreen = (code) => {
  itemCode = code;
  errors.value = '';
  errorId.value = '';
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const refresh = () => {
  itemCode = "";
  checking.value = false;
  massContact.value = [];
  contactsJson = [];
  errors.value = '';
  success.value = '';
  errorId.value = '';
  telSizeResult.value = 0;
  telFormatResult.value = 0;
  duplicateTelResult.value = 0;
  totalChecking = 0;
  checkingResult = true;
  const fileInput = document.getElementById("fileUpload") as HTMLInputElement;
  if (fileInput) fileInput.value = '';
}

const save = () => {
  if (edit == 0) {
    storeContact()
  } else {
    updateContact()
  }
}

const storeBulkContact = () => {
  btnLoad.value = false;
  if (contactsJson.length > 0) {
    try {
      axios.post(`${backApi}/secure/contactbooks/new/bulk`, {
        user: codeUser,
        contacts: contactsJson
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 200) {
          showToast("Contacts enregistrés avec succès", "green");
          contactsJson = [];
          loadAllContacts();
          // Fermer la modale
          const modal = document.getElementById('importContact');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
    } catch (error) {
      console.error(error);
      errors.value = "une erreur inattendue est apparue"
    }
  }
  btnLoad.value = true;
}

const sendMoney = () => {
  btnLoad.value = false;
  if (parseFloat(formValues.amount) > 0 && parseFloat(formValues.amount) <= balance && selectedOperator.value !== '') {
    try {
      schema.validateSync(formValues);

      axios.post(`${backApi}/secure/transactions/init`, {
        clientId: formValues.first_name + " " + formValues.last_name,
        operator: selectedOperator.value,
        amount: parseFloat(formValues.amount),
        mobile: formValues.phone,
        operationType: parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE),
        countryCode: country_code,
        business: selectedBusiness.value,
        successUrl: "https://billing.api/success",
        errorUrl: "https://billing.api/error"
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 201) {
          showToast("Transfert réussi", "green");
          formValues.amount = 0;
          formValues.phone = '';
          selectedOperator.value = '';
          // Fermer la modale
          const modal = document.getElementById('companyModal1');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
    } catch (error) {
      console.error(error);
      errors.value = "une erreur inattendue est apparue"
    }
  } else {
    if (parseFloat(formValues.amount) == 0 || parseFloat(formValues.amount) > balance) {
      showToast("Veuillez saisir un montant correct", "red");
    } else {
      showToast("Veuillez sélectionner un opérateur", "red");
    }
  }
  btnLoad.value = true;
}

const storeContact = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/contactbooks/new`, {
      last_name: formValues.last_name,
      first_name: formValues.first_name,
      organization: codeOrganization,
      user: codeUser,
      contact: formValues.phone,
      country_code: country_code.toUpperCase()
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        loadAllContacts();
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateContact = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/contactbooks/${itemCode}/edit`, {
      last_name: formValues.last_name,
      first_name: formValues.first_name,
      organization: codeOrganization,
      user: codeUser,
      contact: formValues.phone,
      country_code: country_code.toUpperCase()
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      edit = 0;
      itemCode = '';
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        loadAllContacts();
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteContact = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/contactbooks/delete`, { headers, data })
      .then(response => {
        if (response.status === 200) {
          btnLoad.value = true;
          showToast("Suppression effectuée avec succès", "green");
          loadAllContacts();
          // Fermer la modale
          const modal = document.getElementById('filterLeadModal');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const handleImageUpload = (event) => {
  loader.value = false;
  checking.value = false;
  const file = event.target.files[0];
  const reader = new FileReader();
  massContact.value = [];
  contactsJson = [];
  errors.value = '';
  success.value = '';
  errorId.value = '';
  telSizeResult.value = 0;
  telFormatResult.value = 0;
  duplicateTelResult.value = 0;
  totalChecking = 0;

  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

    var i = 0;
    for (const row of jsonData) {
      if ((row[0] !== undefined && row[0] !== 'NOM') && (row[1] !== undefined && row[1] !== 'PRENOM') && (row[2] !== undefined && row[2] !== 'PHONE_NUMBER')) {
        const user = {
          first_name: row[1],
          last_name: row[0],
          contact: row[2],
          country_code: selectedCountry.value
        };
        contactsJson.push(user);
        i++;
      }
    }

    telSizeResult.value = checkTelSize(contactsJson, phoneMask, "contact");
    telFormatResult.value = checkTelFormat(contactsJson, "contact");
    duplicateTelResult.value = checkDuplicateTelBis(contactsJson, "contact");
    totalChecking = telSizeResult.value + telFormatResult.value + duplicateTelResult.value;

    if (totalChecking == 0) {
      massContact.value = contactsJson;
      checkingResult = false;
    }
  };

  loader.value = true;
  checking.value = true;
  reader.readAsArrayBuffer(file);
}

onMounted(async () => {
  checkSessionValidate(1);
  await loadAllContacts();
  getBalancePayout();
  getOperators();
  getBusiness();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000);

  const inputc = document.querySelector("#phone");
  if (inputc) {
    iti = intlTelInput(inputc, {
      onlyCountries: ["ci", "sn"],
      initialCountry: "auto",
      geoIpLookup: function (callback) {
        fetch("https://ipapi.co/json")
          .then(function (res) { return res.json(); })
          .then(function (data) { callback(data.country_code); })
          .catch(function () { callback("ci"); });
      }
    });
  }

  
  const inputTransfer = document.querySelector("#phone_transfer");
  if (inputTransfer) {
    intlTelInput(inputTransfer, {
      onlyCountries: ["ci", "sn"],
      initialCountry: "auto",
      geoIpLookup: function (callback) {
        fetch("https://ipapi.co/json")
          .then(function (res) { return res.json(); })
          .then(function (data) { callback(data.country_code); })
          .catch(function () { callback("ci"); });
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('contacts.search')
              }, null, 8, _hoisted_5), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(current_permissions)('create_contact'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('contacts.addContact')) + " ", 1),
                    _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_unref(current_permissions)('create_contact'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#importContact",
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('contacts.massImport')) + " ", 1),
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('contacts.code')), 1),
                    (_unref(current_permissions)('SUPERADMIN'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_ctx.$t('contacts.organization')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('contacts.firstName')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('contacts.lastName')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('contacts.phoneNumber')), 1),
                    _cache[22] || (_cache[22] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedContacts.value, (contact) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: contact.code
                    }, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(contact.code), 1),
                      (_unref(current_permissions)('SUPERADMIN'))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(contact.organization?.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(contact.first_name), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(contact.last_name), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(contact.contact), 1),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[26] || (_cache[26] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_22, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#companyModal1",
                                onClick: ($event: any) => (showTransfert(contact.code))
                              }, [
                                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('contacts.transfer')), 1)
                              ], 8, _hoisted_23)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('delete_contact'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    style: {"color":"red"},
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#filterLeadModal",
                                    onClick: ($event: any) => (showScreen(contact.code))
                                  }, [
                                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('contacts.delete')), 1)
                                  ], 8, _hoisted_25))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('edit_contact'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showContact(contact.code))
                                  }, [
                                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('contacts.edit')), 1)
                                  ], 8, _hoisted_27))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (filteredTotal.value>pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_ctx.$t('contacts.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                        _createTextVNode(_toDisplayString(_ctx.$t('contacts.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_36, [
                    _createElementVNode("ul", _hoisted_37, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_39, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (goToPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_40))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[28] || (_cache[28] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("h1", _hoisted_46, _toDisplayString(_ctx.$t('contacts.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              (errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_49, _toDisplayString(_ctx.$t('contacts.confirmDelete')), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("h6", _hoisted_51, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_52, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('contacts.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteContact()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('contacts.yes')), 1)
            ], 8, _hoisted_54)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h1", _hoisted_61, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('contacts.addContact') : _ctx.$t('contacts.editContact')), 1),
              _cache[29] || (_cache[29] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_62, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("h6", _hoisted_64, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_65, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("h6", _hoisted_67, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('contacts.phoneNumber')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.phone) = $event)),
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phone'] }]),
                        placeholder: _ctx.$t('contacts.phonePlaceholder'),
                        id: "phone",
                        onKeyup: _cache[7] || (_cache[7] = ($event: any) => (handlePhone($event.target.value,$event.target))),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (handlePhone($event.target.value,$event.target)))
                      }, null, 42, _hoisted_72), [
                        [_vModelText, formValues.phone]
                      ]),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(errorsBis['phone']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('contacts.firstName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['first_name'] }]),
                        placeholder: _ctx.$t('contacts.firstNamePlaceholder'),
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formValues.first_name) = $event)),
                        id: "first_name",
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (validate('first_name')))
                      }, null, 42, _hoisted_76), [
                        [_vModelText, formValues.first_name]
                      ]),
                      _createElementVNode("span", _hoisted_77, _toDisplayString(errorsBis['first_name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('contacts.lastName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['last_name'] }]),
                        placeholder: _ctx.$t('contacts.lastNamePlaceholder'),
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formValues.last_name) = $event)),
                        id: "last_name",
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (validate('last_name')))
                      }, null, 42, _hoisted_80), [
                        [_vModelText, formValues.last_name]
                      ]),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(errorsBis['last_name']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              (_unref(current_permissions)('create_contact'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_83, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_84))
                      : _createCommentVNode("", true),
                    _cache[30] || (_cache[30] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('contacts.save') : _ctx.$t('contacts.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(sendMoney, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("h1", _hoisted_89, _toDisplayString(_ctx.$t('contacts.transferMoney')), 1),
              _cache[31] || (_cache[31] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("h6", _hoisted_92, _toDisplayString(_ctx.$t('contacts.balance')), 1),
                _createElementVNode("h6", _hoisted_93, _toDisplayString(payoutBalance.value?.toLocaleString()) + " XOF", 1)
              ]),
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _createElementVNode("h6", _hoisted_95, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_96, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createElementVNode("h6", _hoisted_98, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t('contacts.phoneNumber')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValues.phone) = $event)),
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phone'] }]),
                        placeholder: _ctx.$t('contacts.phonePlaceholder'),
                        id: "phone_transfer",
                        readonly: ""
                      }, null, 10, _hoisted_103), [
                        [_vModelText, formValues.phone]
                      ]),
                      _createElementVNode("span", _hoisted_104, _toDisplayString(errorsBis['phone']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t('contacts.firstName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['first_name'] }]),
                        placeholder: _ctx.$t('contacts.firstNamePlaceholder'),
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formValues.first_name) = $event)),
                        readonly: ""
                      }, null, 10, _hoisted_107), [
                        [_vModelText, formValues.first_name]
                      ]),
                      _createElementVNode("span", _hoisted_108, _toDisplayString(errorsBis['first_name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t('contacts.lastName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['last_name'] }]),
                        placeholder: _ctx.$t('contacts.lastNamePlaceholder'),
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formValues.last_name) = $event)),
                        readonly: ""
                      }, null, 10, _hoisted_111), [
                        [_vModelText, formValues.last_name]
                      ]),
                      _createElementVNode("span", _hoisted_112, _toDisplayString(errorsBis['last_name']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('contacts.operators')), 1),
                    _createElementVNode("select", {
                      name: "operator",
                      id: "operator",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleOperatorChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_116, _toDisplayString(_ctx.$t('contacts.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: operator.mnoName,
                          key: operator.code
                        }, _toDisplayString(operator.mnoName), 9, _hoisted_117))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('contacts.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['amount'] }]),
                        placeholder: _ctx.$t('contacts.amountPlaceholder'),
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.amount) = $event)),
                        id: "amount",
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (validate('amount'))),
                        onKeyup: _cache[18] || (_cache[18] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target)))
                      }, null, 42, _hoisted_120), [
                        [_vModelText, formValues.amount]
                      ]),
                      _createElementVNode("span", _hoisted_121, _toDisplayString(errorsBis['amount']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t('contacts.business')), 1),
                    _createElementVNode("select", {
                      name: "business",
                      id: "business",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleBusinessChange
                    }, [
                      _createElementVNode("option", _hoisted_124, _toDisplayString(_ctx.$t('contacts.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.value, (businessItem) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: businessItem.code,
                          key: businessItem.code
                        }, _toDisplayString(businessItem.name), 9, _hoisted_125))
                      }), 128))
                    ], 32)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("button", _hoisted_127, [
                (!btnLoad.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_128))
                  : _createCommentVNode("", true),
                _cache[32] || (_cache[32] = _createElementVNode("i", {
                  class: "flaticon-plus position-relative ms-5 fs-12",
                  style: {"color":"#FFF"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.transfer')), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_129, [
      _createElementVNode("div", _hoisted_130, [
        _createElementVNode("div", _hoisted_131, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeBulkContact, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("h1", _hoisted_133, _toDisplayString(_ctx.$t('contacts.importContacts')), 1),
              _cache[33] || (_cache[33] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_134, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                    _createElementVNode("h6", _hoisted_136, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_137, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                    _createElementVNode("h6", _hoisted_139, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (checking.value==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                    _createElementVNode("h6", {
                      style: {"width":"90%"},
                      class: _normalizeClass((_unref(telSizeResult)==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0')
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('contacts.phoneSizeError')) + " ", 1),
                      _createElementVNode("span", _hoisted_141, _toDisplayString(_unref(telSizeResult)), 1)
                    ], 2),
                    _createElementVNode("h6", {
                      style: {"width":"90%"},
                      class: _normalizeClass((_unref(telFormatResult)==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0')
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('contacts.phoneFormatError')) + " ", 1),
                      _createElementVNode("span", _hoisted_142, _toDisplayString(_unref(telFormatResult)), 1)
                    ], 2),
                    _createElementVNode("h6", {
                      style: {"width":"90%"},
                      class: _normalizeClass((_unref(duplicateTelResult)==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0')
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('contacts.duplicatePhoneError')) + " ", 1),
                      _createElementVNode("span", _hoisted_143, _toDisplayString(_unref(duplicateTelResult)), 1)
                    ], 2),
                    (_unref(totalChecking)==0)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_144, _toDisplayString(_ctx.$t('contacts.proceedImport')), 1))
                      : _createCommentVNode("", true),
                    (_unref(totalChecking)>0)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_145, _toDisplayString(_ctx.$t('contacts.correctErrors')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (checking.value==true)
                ? (_openBlock(), _createElementBlock("hr", _hoisted_146))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.$t('contacts.download')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                        type: "button",
                        onClick: getModelExcel
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('contacts.templateFile')) + " ", 1),
                        _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.$t('contacts.country')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("select", {
                        name: "country",
                        id: "country",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleCountryChange,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_153, _toDisplayString(_ctx.$t('contacts.selectCountry')), 1),
                        _createElementVNode("option", _hoisted_154, _toDisplayString(_ctx.$t('contacts.senegal')), 1),
                        _createElementVNode("option", _hoisted_155, _toDisplayString(_ctx.$t('contacts.ivoryCoast')), 1)
                      ], 32),
                      _createElementVNode("span", _hoisted_156, _toDisplayString(errorsBis['phone']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('contacts.uploadFile')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        id: "fileUpload",
                        type: "file",
                        onChange: handleImageUpload,
                        readonly: ""
                      }, null, 32),
                      _createElementVNode("span", _hoisted_159, _toDisplayString(errorsBis['first_name']), 1)
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("button", {
                      class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                      type: "button",
                      style: {"background-color":"#EB9355","visibility":"hidden"},
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#ckeckingResult",
                      id: "toastElement"
                    }, [
                      _createElementVNode("i", { class: "flaticon-close position-relative ms-5 top-2 fs-15" })
                    ], -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("table", _hoisted_161, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_162, _toDisplayString(_ctx.$t('contacts.lastName')), 1),
                      _createElementVNode("th", _hoisted_163, _toDisplayString(_ctx.$t('contacts.firstName')), 1),
                      _createElementVNode("th", _hoisted_164, _toDisplayString(_ctx.$t('contacts.phoneNumber')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(massContact.value, (massContactItem) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: massContactItem.contact
                      }, [
                        _createElementVNode("th", _hoisted_165, [
                          _createElementVNode("div", _hoisted_166, [
                            _createElementVNode("div", _hoisted_167, _toDisplayString(massContactItem.last_name), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_168, _toDisplayString(massContactItem.first_name), 1),
                        _createElementVNode("td", _hoisted_169, _toDisplayString(massContactItem.contact), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_170, [
              _createElementVNode("button", {
                type: "button",
                class: "default-outline-btn bg-transparent fw-medium rounded-1 pt-12 pb-12 ps-25 pe-25",
                onClick: refresh
              }, _toDisplayString(_ctx.$t('contacts.refresh')), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn text-white",
                style: {"background-color":"#EB9355"},
                disabled: _unref(checkingResult)
              }, [
                (!btnLoad.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_172))
                  : _createCommentVNode("", true),
                _cache[36] || (_cache[36] = _createElementVNode("i", {
                  class: "flaticon-plus position-relative ms-5 fs-12",
                  style: {"color":"#FFF"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('contacts.save')), 1)
              ], 8, _hoisted_171)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[37] || (_cache[37] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})